module.exports = __webpack_public_path__ + "static/img/022白桦节2稿.086e010.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/022白桦节2稿.jpg
// module id = 0MfJ
// module chunks = 0